export default {
    nav: {
        home: "Home",
        solutions: "Solutions",
        programmes: "Programs & Capacity Building",
        expertises: "Expertise",
        sourcing: "Sourcing",
        about: "About",
        analyses: "Insights",
        contact: "Contact",
        cta: "Book a 30-min call",
    },
    hero: {
        eyebrow: "International development consulting — France · Tunisia",
        line1: "Grow your business",
        line2a: "",
        line2b: "internationally",
        line2c: ",",
        line3: "from strategy to execution",
        intro: "WEYB is an international business development consultancy. We help companies, leaders and export teams move from decision to action — strategy, execution, fieldwork, technology and human support.",
        ctaPrimary: "Book a 30-min call with Saber",
        ctaSecondary: "Discover our solutions",
        zoneNote: "France — head office · Tunisia — subsidiary · international partner network",
    },
    marquee: ["Export strategy", "Market studies", "B2B prospecting", "International trade fairs", "B2B missions", "Export coaching", "International setup", "Export360"],
    solutions: {
        eyebrowIndex: "01",
        eyebrow: "Four areas of intervention",
        title: "From your first market study to your local footprint.",
        cards: [
            {
                num: "01",
                title: "International development",
                value: "From strategy to field execution, end-to-end support for your export growth.",
                items: ["Export diagnosis & strategy", "Market studies & prioritisation", "B2B prospecting & closing", "Trade fairs & B2B missions"],
                cta: "Discover the solution",
            },
            {
                num: "02",
                title: "Support Programs & Capacity Building",
                value: "Design, training, implementation and evaluation of internationalisation programmes, alongside support organisations and development partners.",
                items: ["Programme design", "Training of Trainers (ToT)", "Business training & coaching", "Monitoring & Evaluation"],
                cta: "Discover the approach",
            },
            {
                num: "03",
                title: "Export360.fr",
                value: "The platform that structures and manages your export development, powered by AI.",
                items: ["Diagnostics & prioritisation", "AI-assisted studies", "E-learning, quizzes & templates", "Studies marketplace & coaches"],
                cta: "Discover Export360",
            },
            {
                num: "04",
                title: "International setup & HR",
                value: "Your local presence, without the friction: entity, teams and operational support.",
                items: ["Entity creation", "Recruitment & payroll solutions", "Admin & accounting support", "Local team setup"],
                cta: "Discover the solution",
            },
        ],
    },
    institutions: {
        eyebrowIndex: "02",
        eyebrow: "Support organisations & institutions",
        title: "Do you support companies going international?",
        text: "WEYB works with support organisations, institutions and development partners to design and implement programmes dedicated to the internationalisation of businesses.",
        stats: [
            { value: "15+", label: "support organisations & BSOs" },
            { value: "300+", label: "SMEs supported" },
            { value: "15+", label: "countries of operation" },
        ],
        blocks: [
            { title: "Programme design", desc: "Turning your objectives into an operational scheme: methodology, learning paths, tools and KPIs." },
            { title: "Training of Trainers", desc: "Training your advisors and trainers to deploy the methodology autonomously." },
            { title: "Training & coaching", desc: "Training and coaching beneficiary companies, individually and collectively." },
            { title: "Implementation", desc: "Coordinating programme rollout and monitoring beneficiary companies." },
            { title: "Monitoring & Evaluation", desc: "Indicators, reporting, evaluation and capitalisation of results." },
        ],
        cta: "Discover our programme approach",
    },
    method: {
        eyebrowIndex: "04",
        eyebrow: "Method",
        title: "A six-step journey, from diagnosis to management.",
        steps: [
            { num: "01", title: "Diagnose", desc: "A complete export diagnosis: potential, capabilities, international readiness." },
            { num: "02", title: "Prioritise", desc: "Ranking the markets with the strongest potential for your offer." },
            { num: "03", title: "Prepare", desc: "Studies, positioning, pitch and sales tools adapted to each market." },
            { num: "04", title: "Prospect", desc: "Identifying and qualifying partners through targeted B2B prospecting." },
            { num: "05", title: "Deploy", desc: "International trade fairs, B2B missions, closing and local setup." },
            { num: "06", title: "Manage", desc: "Monitoring, indicators and continuous management of your export growth." },
        ],
    },
    export360: {
        eyebrowIndex: "05",
        eyebrow: "Export360 — the platform",
        titleA: "Your export development,",
        titleB: " structured and managed",
        titleC: ".",
        desc: "Export360 is the platform developed by WEYB to structure, manage and accelerate companies' international growth — from initial diagnosis to business opportunities.",
        features: ["Export diagnostics", "Market prioritisation", "AI-assisted studies", "Trade fair & mission preparation", "Templates & e-learning", "Quizzes & leaderboard", "AI chatbot", "Studies marketplace", "Coaches & consultants", "Business opportunities"],
        cta: "Discover Export360.fr",
        visualAlt: "The Export360 platform: diagnostics, management tools and AI-assisted studies",
        visualNote: "Temporary visual — official screenshots to be integrated",
    },
    zones: {
        eyebrowIndex: "06",
        eyebrow: "Regions & sectors",
        title: "A European, African and MENA presence. Multisector experience.",
        zonesTitle: "Where we operate",
        zonesNote: "Based in France, a subsidiary in Tunisia, and a network of international partners and experts.",
        zones: ["Europe", "Africa", "MENA"],
        zonesImgAlt: "International trade fair — WEYB field presence",
        sectorsTitle: "Sectors of experience",
        sectors: ["Agrifood", "Industry", "B2B services", "Technology solutions"],
        sectorsNote: "Priority areas of experience — our support adapts to any exportable sector.",
    },
    experiences: {
        eyebrowIndex: "03",
        eyebrow: "Ecosystem & references",
        title: "Institutional experience and collaborations.",
        note: "Programmes, missions and collaborations within this ecosystem — donors, support organisations, chambers of commerce and accelerators.",
    },
    founder: {
        eyebrowIndex: "08",
        eyebrow: "The founder",
        name: "Saber Bellaaj",
        role: "Founder & CEO of WEYB",
        bio: "Over twenty years in the field of international trade: export strategy, international business development, coaching and operational support for companies across Europe, Africa and the MENA region.",
        stats: [
            { value: "20+", label: "years in international trade" },
            { value: "3", label: "regions: Europe · Africa · MENA" },
            { value: "4", label: "languages: EN · FR · AR · IT" },
            { value: "Coach", label: "certified, supporting leaders & teams" },
        ],
        cta: "Discover WEYB and its founder",
        portraitAlt: "Saber Bellaaj, Founder & CEO of WEYB",
    },
    analyses: {
        eyebrowIndex: "09",
        eyebrow: "Insights & publications",
        title: "Field perspectives on international trade.",
        ctaAll: "View all insights",
        emptyTitle: "The first insights are coming soon.",
        emptyText: "Market studies, mission debriefs and export analysis — published by Saber Bellaaj.",
    },
    finalCta: {
        eyebrow: "Next step",
        title: "Let's talk about your international project.",
        desc: "Thirty minutes with Saber Bellaaj to review your ambitions, your target markets and the first actions to launch.",
        ctaPrimary: "Book a 30-min call with Saber",
        ctaSecondary: "Write to us",
    },
    footer: {
        definition: "An international business development consultancy. From strategy to execution, alongside companies across Europe, Africa and the MENA region.",
        france: "France",
        tunisia: "Tunisia",
        col1Title: "Solutions",
        col1: ["International development", "Programs & Capacity Building", "Export360", "International setup & HR"],
        col2Title: "Company",
        col2: ["About WEYB", "Saber Bellaaj", "Insights & Resources", "Contact"],
        ctaTitle: "Let's talk",
        ctaText: "An international project? A first call, no commitment.",
        ctaButton: "Book a 30-min call",
        rights: "WEYB. All rights reserved.",
        legal1: "Legal notice",
        legal2: "Privacy policy",
        legal3: "Cookie preferences",
    },
    solutionsPage: {
        eyebrowIndex: "Solutions",
        eyebrow: "Four areas of intervention",
        title: "From strategy to execution, four ways to accelerate your international growth.",
        intro: "WEYB supports companies, leaders and export teams from strategic decision to operational execution — with Export360 technology and field presence in Europe, Africa and MENA.",
        ctaTitle: "Unsure where to start?",
        ctaText: "A 30-minute call is often enough to clarify the priority.",
        ctaButton: "Book a 30-min call",
    },
    solutionDetail: {
        breadcrumbHome: "Home",
        breadcrumbSolutions: "Solutions",
        eyebrowLabel: "Solution",
        ctaBooking: "Book a 30-min call",
        ctaContact: "Write to us",
        constatEyebrow: "The challenge",
        constatTitle: "Why it is difficult without support.",
        pourQuiEyebrow: "Who it's for",
        pourQuiTitle: "Designed for teams ready to take action.",
        actionsEyebrow: "What WEYB does",
        actionsTitle: "{n} levers of action, one single point of contact.",
        livrablesEyebrow: "Expected outcomes",
        livrablesTitle: "Concrete deliverables, not promises.",
        faqEyebrow: "FAQ",
        faqTitle: "Frequently asked questions.",
        ctaTitle: "Let's talk about your international project.",
        ctaText: "Thirty minutes with Saber Bellaaj to frame your priorities.",
        ctaButton: "Book a 30-min call",
        nextLabel: "Next solution",
    },
    expertisesPage: {
        eyebrowIndex: "Expertise",
        eyebrow: "Five fields of intervention",
        title: "Field expertise, from export diagnosis to B2B missions.",
        intro: "Each WEYB expertise corresponds to a concrete step of your international development — and fits into a complete journey, from strategy to execution.",
        ctaTitle: "Which expertise should you mobilise first?",
        ctaText: "A 30-minute call is enough to determine it together.",
        ctaButton: "Book a 30-min call",
    },
    expertiseDetail: {
        breadcrumbHome: "Home",
        breadcrumbExpertises: "Expertise",
        eyebrowLabel: "Expertise",
        ctaBooking: "Book a 30-min call",
        ctaContact: "Write to us",
        pointsEyebrow: "What this expertise covers",
        pointsTitle: "A precise scope, careful execution.",
        outcomesEyebrow: "What you gain",
        outcomesTitle: "Tangible outcomes.",
        solutionLink: "This expertise is part of {label}",
        ctaTitle: "Let's talk about your international project.",
        ctaText: "Thirty minutes with Saber Bellaaj to frame your priorities.",
        ctaButton: "Book a 30-min call",
        nextLabel: "Next expertise",
    },
    apropos: {
        heroEyebrow: "The firm",
        heroEyebrowIndex: "About",
        heroTitle: "WEYB, your international growth partner.",
        heroIntro: "WEYB is an international business development consultancy, based in France with a subsidiary in Tunisia. We support companies, leaders and export teams from strategy to operational execution, in Europe, Africa and the MENA region.",
        historyEyebrow: "Our story",
        historyTitle: "A field journey, since 2011.",
        timeline: [
            { year: "2011", title: "Origins in Tunisia", text: "The activity began with BMCC in Tunisia: supporting companies and first international development missions." },
            { year: "2022", title: "WEYB founded in Marseille", text: "Saber Bellaaj founded WEYB in Marseille to structure support for companies, from export strategy to operational execution." },
            { year: "Today", title: "A France — Tunisia firm, open to the world", text: "WEYB continues its development from France, with a subsidiary in Tunisia and an international network of partners, experts and consultants." },
        ],
        founderEyebrow: "The founder",
        founderRole: "Founder & CEO of WEYB",
        founderBio: "Over 20 years of experience in international trade: export strategy, business development, coaching and operational support for companies in Europe, Africa and the MENA region. Expertise built in the field, in direct contact with companies and institutions.",
        coachBadge: "Certified coach",
        chainExpertises: "Expertise",
        portraitAlt: "Saber Bellaaj, Founder & CEO of WEYB",
        pillarsEyebrow: "Four pillars",
        pillarsTitle: "A structured offer, from consulting to operations.",
        pillars: [
            { title: "International development", desc: "Diagnosis, strategy, studies, B2B prospecting, trade fairs and missions — the complete export journey.", cta: "Discover" },
            { title: "Support Programs & Capacity Building", desc: "Design, training, implementation and evaluation of internationalisation programmes, with support organisations and development partners.", cta: "Discover" },
            { title: "Export360", desc: "The platform that structures and manages export development, powered by AI.", cta: "Discover" },
            { title: "International setup & HR", desc: "Entity creation, recruitment, payroll solutions and operational support.", cta: "Discover" },
        ],
        coachingEyebrow: "Coaching & training",
        coachingTitle: "Passing on, as much as supporting.",
        coachingList: [
            "Export coaching for leaders",
            "Sales team support",
            "International trade training",
            "International business development",
            "Prospecting and export strategy",
            "Trade fair and mission preparation",
        ],
        qualiopiNote: "WEYB is currently in the process of Qualiopi certification. When necessary, WEYB can intervene with a certified partner.",
        agileEyebrow: "An agile model",
        agileTitle: "A tight core team, an international network.",
        agileText: "WEYB operates as an agile firm: a tight central team, strengthened by a network of partners, experts and international consultants mobilised according to the markets and needs of each mission.",
        presenceTitle: "International presence",
        presenceRows: [
            { place: "France", role: "Head office — Marseille" },
            { place: "Tunisia", role: "Subsidiary" },
            { place: "Europe · Africa · MENA", role: "Partner network" },
        ],
        refsEyebrow: "Ecosystem & references",
        refsTitle: "Institutional experience and collaborations.",
        galleryEyebrow: "In the field",
        galleryTitle: "Our missions, in pictures.",
        galleryNote: "Training sessions, trade fairs, B2B missions and company visits — WEYB's activity, in the field, across Europe, Africa and the MENA region.",
        ctaTitle: "Want to work with WEYB?",
        ctaPrimary: "Book a 30-min call with Saber",
        ctaSecondary: "Discover our solutions",
    },
    contact: {
        eyebrow: "Let's talk about your project",
        eyebrowIndex: "Contact",
        title: "An international project? Write to us.",
        labelPrenom: "First name *",
        labelNom: "Last name *",
        labelEntreprise: "Company",
        labelEmail: "Professional email *",
        labelPays: "Country",
        labelBesoin: "Need",
        labelMessage: "Message *",
        phPrenom: "Your first name",
        phNom: "Your last name",
        phEntreprise: "Your company name",
        phEmail: "firstname@company.com",
        phPays: "France, Tunisia, Morocco…",
        phMessage: "Describe your project, your target markets, your timeline…",
        besoins: ["International development", "Export360", "International setup & HR", "Coaching & Training", "Other need"],
        submit: "Send the message",
        sending: "Sending…",
        successTitle: "Message received.",
        successText: "Thank you for your message. We will get back to you shortly. To move faster, you can also book a 30-minute call directly.",
        successCta: "Book a 30-min call",
        errorFallback: "An error occurred. Please try again or book a call directly.",
        asideTitle: "More direct: 30 minutes with Saber.",
        asideText: "A first call, free of commitment, to frame your project and identify next steps.",
        asideCta: "Book a slot",
        franceNote: "Head office — details being validated",
        tunisiaNote: "Subsidiary — details being validated",
    },
    analysesPage: {
        eyebrow: "Resources & publications",
        eyebrowIndex: "Insights",
        title: "Market analysis, field debriefs and export guides.",
        intro: "International trade analysis by Saber Bellaaj and the WEYB team: studies, missions, trade fairs and export strategy.",
        emptyTitle: "The first insights are coming soon.",
        emptyText: "No content is carried over from the former site without validation — the editorial migration will follow a dedicated inventory.",
    },
    stub: {
        eyebrow: "WEYB.fr — Phased construction",
        titleSuffix: " — this page is coming soon.",
        text: "In line with the validated work plan, pages are built and validated in stages.",
        backHome: "Back to homepage",
        cta: "Book a 30-min call",
    },
    notfound: {
        eyebrow: "Error 404",
        title: "This page does not exist anymore.",
        text: "The content you are looking for may have been moved during the site redesign. Here are the main shortcuts:",
        home: "Back to homepage",
        solutions: "Discover our solutions",
        contact: "Contact us",
    },
    testimonials: {
        eyebrowIndex: "07",
        eyebrow: "Testimonials",
        title: "What they say about their experience with WEYB.",
        note: "Testimonials gathered through real missions and collaborations.",
    },
};
